<template>
  <header class="content-header content-header-scrolled">
    <div class="content-header-itens container">
      <router-link tag="a" to="/" class="content-header-itens-logo">
        <img src="@/assets/img/logo-white.png" alt="logo">
      </router-link>
      <div class="content-header-itens-links">
        <router-link tag="a" to="/" class="content-header-itens-link-items v-content-header-int" :class="{ 'link-active': $route.name === 'Client' }" v-contentHeaderInt="{ section: 'Header Interna', removeHtml: true }">
          Cliente
        </router-link>
        <router-link tag="a" to="/comerciante" class="content-header-itens-link-items v-content-header-int" :class="{ 'link-active': $route.name === 'Merchant' }" v-contentHeaderInt="{ section: 'Header Interna', removeHtml: true }">
          Comerciante
        </router-link>
        <router-link to="/cuenta" class="content-header-itens-link-items v-content-header-int" :class="{ 'link-active': $route.name === 'Account' || 'CreateAccount' }" v-contentHeaderInt="{ section: 'Header Interna', removeHtml: true }">
          A sua conta
        </router-link>
        <!-- <div class="content-header-itens-account-language">
          <LanguageList />
        </div> -->
      </div>
      <div class="content-menu d-lg-none" @click="setMenuOpen(true)">
        <div class="content-menu-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="18" viewBox="0 0 30 18">
                <g id="Group_6118" data-name="Group 6118" transform="translate(-325 -56)">
                    <line id="Line_3" data-name="Line 3" x1="28" transform="translate(326 57)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
                    <line id="Line_4" data-name="Line 4" x1="28" transform="translate(326 65)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
                    <line id="Line_5" data-name="Line 5" x1="28" transform="translate(326 73)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
                </g>
            </svg>
        </div>
      </div>
    </div>
    <Login />
  </header>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import axios from 'axios';
import store from '@/store';
import Login from "../modals/Login.vue";

const allContents = [];
const lang = localStorage.getItem('locale') || 'es';

export default {
  data() {
    return {
      openMenuDesktop: false,
    };
  },
  components: {
    Login,
  },
  props: {
    isScrolled: Boolean,
    isScrolledMobile: Boolean,
  },
  computed: {
    ...mapGetters(['isDesktop', 'activeMenuFooter', 'activeFormFloating','userIsLogged', 'user']),
    ...mapState('App', ['loading']),
  },
  methods: {
    ...mapMutations(['setActiveMenuFooter',]),
    ...mapActions(["setMenuOpen","toggleFormFixed"]),
    menuDesktopOpen(){
      this.openMenuDesktop = !this.openMenuDesktop;
    },
    scrollToElement() {
      if (this.$route.name !== 'Home') {
        localStorage.setItem('scrollToElement', true);
        window.location.href = '/';
      }
      setTimeout(() => {
        this.$scrollTo('#form-contact', 800, { easing: 'linear' });
      }, 1000);
    },
    updateDirectives() {
        const allElements = document.querySelectorAll('.v-content-header-int');
        allContents.splice(0, allContents.length); // clear the contents array
        allElements.forEach((el) => {
            const params = el.dataset.params ? JSON.parse(el.dataset.params) : {};
            params.content = el.innerHTML.trim();
            if (!('type' in params)) params.type = 'text';
            params.theme = process.env.VUE_APP_THEME;
            params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
            allContents.push(params);
        });
    },

  },
  created() {
    this.updateDirectives();
  },
  directives: {
    contentHeaderInt: {
      inserted: async function (el, binding) {
        const allElements = document.querySelectorAll('.v-content-header-int');
        let params = binding.value ? binding.value : {};
        params.content = el.innerHTML.trim();
        if (!('type' in params)) params.type = 'text';
        params.theme = process.env.VUE_APP_THEME;
        params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
        allContents.push(params);

        if (allElements.length == allContents.length) {
          store.dispatch('App/loading', true);
          await axios({
            method: "POST",
            url: '/api/v1/site/get-all-contents',
            data: { allContents, lang }
          })
            .then(response => response.data)
            .then((data) => {
              const allElements = document.querySelectorAll('.v-content-header-int');
              allContents.forEach((el) => {
                if (el.type == 'text') {
                  allElements.forEach((el, index) => {
                    el.innerHTML = data.data[index];
                  });
                }
              });
              store.dispatch('App/loading', false);
            });
        }
      },

    }
  },
};
</script>


<style lang="scss" scoped>
@import "./style.scss";
</style>